export default __webpack_public_path__ + "static/media/uhs.f618b839.svg";